import { CONTENT as liveCs } from '@flowup/content/generated/live/cs/content';
import { CONTENT as liveEn } from '@flowup/content/generated/live/en/content';
import { EnvironmentModel } from '../app/common/models';

/** Share of visits that carry a performance trace. */
const SENTRY_TRACES_SAMPLE_RATE = 0.3;

export const environment: EnvironmentModel = {
  appEnv: 'production',
  sentry: {
    dsn: 'https://6cdc6102b8cd49aca4da3183943ad0ba@o401493.ingest.sentry.io/5261167',
    environment: 'production',
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
  },
  content: { en: liveEn, cs: liveCs },
};
